<template>
  <Card
    :title="title"
    :subtitle="subtitle"
    :divider="false"
    :rounded="maxSmall ? 'xl' : 'sm'"
    class="md:pt-1 md:px-2 shadow-xs"
  >
    <template v-if="$slots.dropdown" #dropdown>
      <slot name="dropdown" />
    </template>
    <slot />
  </Card>
</template>

<script setup>
import { Card } from "@/SharedComponents/Cards";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, required: false },
});
</script>
